import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import {
	AlertComponent,
	CardSelectComponent,
	DividerComponent,
	InputComponent,
	ItemComponent,
	ListDetailComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { CONNECTION_TYPE, IDocumentsDocs, OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';
import { WorkflowFormAdvancedCollapseComponent } from '../workflow-form-advanced-collapse.component';

/**
 * Panel UI de CONNECTIONS (evaluación financiera) en el editor (NIF-530).
 * Abrir cuando: tipo scoring/verify, métodos de conexión o tries.
 */
@Component({
	selector: 'app-workflow-form-connections-panel',
	imports: [
		WorkflowFormAdvancedCollapseComponent,
		ReactiveFormsModule,
		UpperCasePipe,
		TranslatePipe,
		TileComponent,
		ItemComponent,
		CardSelectComponent,
		InputComponent,
		ListDetailComponent,
		DividerComponent,
		AlertComponent,
	],
	templateUrl: './workflow-form-connections-panel.component.html',
})
export class WorkflowFormConnectionsPanelComponent extends WorkflowFormOperationPanelBase {
	protected readonly operationType = OPERATION_TYPE.CONNECTIONS;

	/** Tipo UI: `scoring` | `verify` | `''`. */
	public get evalType(): string {
		return String(this.group.get('type')?.value ?? '');
	}

	public setEvalType(next: 'scoring' | 'verify', selected: boolean): void {
		this.patchControl('type', selected ? next : '');
		if (next === 'verify') {
			this.host.changeAvailableFinancialEvaluation(selected, CONNECTION_TYPE.BANK_SCORING);
		}
	}

	public hasConnection(type: CONNECTION_TYPE): boolean {
		const list = this.group.get('connections')?.value as CONNECTION_TYPE[] | undefined;
		return Boolean(list?.includes(type));
	}

	public changeAvailableFinancialEvaluation(status: boolean, connection: CONNECTION_TYPE): void {
		this.host.changeAvailableFinancialEvaluation(status, connection);
	}

	public isConnectionDisabled(type: CONNECTION_TYPE): boolean {
		return this.host.isConnectionDisabled(type);
	}

	public getDuplicateConnection(): IDocumentsDocs[] {
		return this.host.getDuplicateConnection();
	}
}
